import Imageone from "../../images/imageone.png";
import Imagetwo from "../../images/imagetwo.png";
import Imagethree from "../../images/imagethree.png";
import Imagefour from "../../images/imagefour.png";
import Imagefive from "../../images/imagefive.png";
import Imagesix from "../../images/imagesix.png";

function Rollpagetwo() {
  return (
    <div
      className="container mx-auto"
      style={{
        padding: "80px 0",
        maxWidth: "1200px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "30px",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        <div className="text-center text-[#1f3121] text-xl leading-relaxed uppercase mt-5 font-bold">
          Trusted by Businesses
        </div>
      </h2>

      <div
        style={{
          display: "flex",
          gap: "15px",
          justifyContent: "center",
          flexWrap: "wrap",
          padding: "20px",
        }}
      >
        {[Imageone, Imagetwo, Imagethree, Imagefour, Imagefive, Imagesix].map(
          (image, index) => (
            <img
              key={index}
              src={image}
              alt={`image${index + 1}`}
              style={{
                width: "160px",
                height: "120px",
                objectFit: "cover",
              }}
            />
          )
        )}
      </div>
    </div>
  );
}

export default Rollpagetwo;
